import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';

import { ScheduleIconBlue } from '../../../../iconRef/mealPLanIcons'
import { CloseModal } from '../../../../iconRef/referralIcons'
import styles from './scheduleMealHeading.module.css'

const ScheduleMealHeading = ({ recipeName, setDrawer }: { recipeName: string, setDrawer:  React.Dispatch<React.SetStateAction<boolean>> }) => (
  <Grid className={styles.heading_container}>
    <Grid className={styles.heading_content}>
      <ScheduleIconBlue />
      <Typography className={styles.heading_text} variant="caption4LightOutfit">Schedule : {recipeName}</Typography>
    </Grid>
    <IconButton onClick={() => setDrawer(false)}><CloseModal /></IconButton>
  </Grid>
)

export default ScheduleMealHeading